import React from "react";

const TileIcon = props => {
  const { color, image, icon, iconColor } = props;
  const Icon = icon;
  return (
    <div
      style={{ backgroundColor: color ? color : "#81cc78" }}
      className="icon"
    >
      <div className="container">
        {icon ? (
          <Icon style={{ color: iconColor ? iconColor : "#f5f5f5" }} />
        ) : (
          image && <img src={image} />
        )}
      </div>
    </div>
  );
};

export default TileIcon;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/TileIcon.js